import React from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import withLoader from '../app/withLoader';
import { withRouter } from 'react-router-dom';
import AddReservationForm from './form/addForm';
import { confirmReservation } from './_api';
import { get } from 'lodash';
import { withSnackbar } from 'notistack';

const styles = (theme) => ({
  root: {
    margin: 10,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    color: theme.palette.text.secondary,
  },
});

const enhance = compose(
  withStyles(styles),
  withLoader,
  withRouter,
  withSnackbar,
  withHandlers({
    onSubmit: ({ history, toggleLoader, enqueueSnackbar }) => async (values) => {
      let servicesForUsers = {};
      Object.keys(values.services).map((personId) => {
        Object.keys(values.services[personId]).map((service) => {
          if (get(servicesForUsers, `[${service}]`)) {
            servicesForUsers[service].push({
              quantity: parseInt(values.services[personId][service], 10),
              personId: parseInt(personId, 10),
            });
          } else {
            servicesForUsers[service] = [
              {
                quantity: parseInt(values.services[personId][service], 10),
                personId: parseInt(personId, 10),
              },
            ];
          }
          return null;
        });
        return null;
      });
      let valuesToSend = {
        userId: values.userId.value,
        note: get(values, 'note', ''),
        discountInPercent: parseFloat(get(values, 'discountInPercent', '0'), 0.0),
        servicesForUsers,
        items: [],
        sendEmail: values.sendEmail,
      };
      get(values, 'persons', []).map((person) => {
        Object.keys(person.items).map((key) => {
          person.items[key].map((itemIn) => {
            if (itemIn && itemIn.item) {
              const item = get(itemIn, 'item.value');
              valuesToSend.items.push({
                requestId: item.requestId,
                personId: person.personId,
                itemId: item.id,
                price: item.price,
                from: values.from,
                to: values.to,
              });
            }
            return {};
          });
          return {};
        });
        return {};
      });
      toggleLoader();
      const resp = await confirmReservation(valuesToSend);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Rezervace byla úspěšně vytvořena.', {
          variant: 'success',
        });
        history.push(`/reservations/${get(resp, 'data.reservationId', '')}`);
      } else {
        enqueueSnackbar('Rezervaci se nepodařilo vytvořit.', {
          variant: 'error',
        });
        console.log(resp.data);
      }
      toggleLoader(false);
    },
  })
);

export default enhance(({ classes, onSubmit, users }) => (
  <div className={classes.root}>
    <Paper className={classes.paper}>
      <AddReservationForm onSubmit={onSubmit} users={users} />
    </Paper>
  </div>
));



// WEBPACK FOOTER //
// ./src/modules/reservations/add.js